import NavBar from "@components/navbar/NavBar";
import CurrencyTab from "@components/currency-tab/CurrencyTab";
import * as _ from "lodash";
import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { connect } from "react-redux";
import Table from "react-bootstrap/esm/Table";
import ApprovalPopup from "src/components/approval-popup/ApprovalPopup";
import RejectionPopup from "src/components/rejection-popup/RejectionPopup";
import { ReactComponent as NextIcon } from "@images/next.svg";
import { ReactComponent as PreviousIcon } from "@images/previous.svg";
import LeftSidebar from "@components/left-sidebar/LeftSidebar";import ScreenLayout from "src/components/layout/ScreenLayout";
import { Row, Col, OverlayTrigger, Dropdown, Tooltip } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import moment from "moment";
import Loader from "@components/loader/Loader";
import CustomButton from "@components/custom-button/CustomButton";
import BankRequestPopup from "@components/bank-request-popup/BankRequestPopup.js";
import { ToastContainer, toast } from "react-toastify";
import Filter from "@components/filter/Filter.js";
import { ReactComponent as VerticleIcon } from "@images/Vertical.svg";
import { ReactComponent as Replacementof3dots } from "@images/replacementof3dots.svg";
import { useTranslation } from "react-i18next";
import PaymentCancelConfirmation from "@components/payment-cancel-confirmation/PaymentCancelConfirmation";
import "@features/admin-bankapproval-request/AdminBankapprovalRequest.scss";

function AdminBankapprovalRequest(props) {
  const {
    exchangeRates,
    createpaymentLink,
    paymenthistory,
    getpaymenthistoryCount,
    myusertransactionloading,
    getplatformTokensinfo,
    getExchangerate,
    getPaymentHistory,
    myaccountandbalance,
    getPaymentHistoryyCount,
    setPaymentlink,
    paymentlinkmodal,
    paymentlinksuccmodal,
    setPaymentlinkSucc,
    paymentToken,
    createloaders,
    paymentbytoken,
    settings,
    thememode,
    getcomissionper,
    commissionPercentage,
    createPaymentFail,
    callAllBankAccountForVerification,
    requestedAccountVerification,
    requestedAccountVerificationLoading,
    approveBankAccount,
    requestBankAccountCount,
    bankAccountCount,
  } = props || {};
  let [pages, setpages] = useState(0);
  let [limit, setlimit] = useState(10);
  let [tableno, settableno] = useState("third");
  let [allBankAccountRequests, setAllBankAccountRequests] = useState([]);
  let [show, setshow] = useState(false);
  let [Idata, setIdata] = useState({});
  const [isFilterSet, setIsFilterSet] = useState(false);

  let [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  let [selectedPaymentID, setSelectedPaymentID] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [show1, setShowApproval] = useState(false);
  const [show2, setShowRejection] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [statusType, setStatusType] = useState("");

  useEffect(() => {
    callAllBankAccountForVerification({ skip: pages, limit });
    bankAccountCount({ status: statusType });
  }, []);

  const { t } = useTranslation();

  return (
    <div id="AdminBankapprovalRequest">
      {requestedAccountVerificationLoading && <Loader />}
      {/* <PaymentCancelConfirmation
        show1={showCancelConfirmation}
        selectedPayment={selectedPaymentID}
        setShowModal={(status) => setShowCancelConfirmation(status)}
      /> */}

      <BankRequestPopup
        show1={show}
        setShowModal={setshow}
        item={selectedItem}
      />

      {/* <NavBar location={useLocation()} /> */}
      <ScreenLayout hideLoaderOnStart={true}>
        <Container className="containertp">
          <Row>
            <Col lg={12}>
              <div className="trouter">
                <div className="transactiontitle">
                  <span className=" title">{t("BankRequest")} </span>
                  <div className="filtersection">
                    <Filter
                      onApplyDate={(picker) => {
                        setIsFilterSet(true);
                        callAllBankAccountForVerification({
                          skip: pages,
                          limit,
                          startDate: picker.startDate,
                          endDate: picker.endDate,
                          status: statusType,
                        });
                        bankAccountCount({
                          status: statusType,
                          startDate: picker.startDate,
                          endDate: picker.endDate,
                        });
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      setStartDate={(e) => setStartDate(e)}
                      setEndDate={(e) => setEndDate(e)}
                      oncancel={() => {
                        setIsFilterSet(false);
                        setStartDate();
                        setEndDate();
                        callAllBankAccountForVerification({
                          skip: pages,
                          limit,
                          status: statusType,
                        });
                        bankAccountCount({ status: statusType });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="actions">
                <div className="btmmargin">
                  <CurrencyTab
                    page={"businessrequest"}
                    changeTab={(e) => {
                      if (e == "second") {
                        setIsFilterSet(false);
                        setStartDate();
                        setEndDate();
                        setStatusType("Rejected");
                        bankAccountCount({ status: "Rejected" });
                        callAllBankAccountForVerification({
                          skip: pages,
                          limit,
                          status: "Rejected",
                        });
                        setpages(0);
                        settableno(e);
                      }
                      if (e == "first") {
                        setIsFilterSet(false);
                        setStartDate();
                        setEndDate();
                        setStatusType("Activated");
                        bankAccountCount({ status: "Activated" });
                        callAllBankAccountForVerification({
                          skip: pages,
                          limit,
                          status: "Activated",
                        });
                        setpages(0);
                        settableno(e);
                      }
                      if (e == "third") {
                        setIsFilterSet(false);
                        setStartDate();
                        setEndDate();
                        setStatusType("");
                        callAllBankAccountForVerification({
                          skip: pages,
                          limit,
                        });
                        bankAccountCount({ status: "" });
                        setpages(0);
                        settableno(e);
                      }
                    }}
                    tableno={tableno}
                  />
                </div>
              </div>

              <Table
                responsive="sm"
                className={`transfertbl ${
                  thememode == "light" ? "tableinlight" : "tableindark"
                }`}
                borderless
              >
                <thead className="hidden-for-mobile">
                  <tr>
                    <th className="trtbleheading ">
                      <span className="heading"> {t("ID")}</span>
                    </th>
                    <th className="trtbleheading">
                      <span className="heading">{t("Date")}</span>
                    </th>
                    <th className="trtbleheading ">
                      <span className="heading">{t("UserName")}</span>
                    </th>
                    <th className="trtbleheading">
                      <span className="heading">{t("BankName")}</span>
                    </th>
                    <th className="trtbleheading">
                      <span className="heading">{t("BankAccountNumber")}</span>
                    </th>
                    <th className="trtbleheading ">
                      <span className="heading">{t("Action")}</span>
                    </th>
                    <th className="trtbleheading"></th>
                  </tr>
                </thead>

                <tbody>
                  {requestedAccountVerification &&
                    requestedAccountVerification.map((item, index) => (
                      <tr
                        key={`trans${index}`}
                        onClick={() => {
                          setIdata(item);
                          // setshow(true);
                        }}
                      >
                        <td className="amt">
                          <div className="innerTd idtr ">
                            <span className="id idtxt">{item.id}</span>
                            <p className="hidden-for-desktop date margintop">
                              {moment(item.createdOn)
                                .local()
                                .format("MM/DD/YYYY hh:mm A")}
                            </p>
                          </div>
                        </td>
                        <td className="amt hidden-for-mobile">
                          <div className="innerTd">
                            {moment(item.createdOn)
                              .local()
                              .format("MM/DD/YYYY hh:mm A")}
                          </div>
                        </td>
                        <td className="amt">
                          <div className="innerTd">
                            <span>
                              {/* {" "}
                            {item.receiver && 
                            item.receiver.profileImage && 
                            item.receiver.profileImage.xs && 
                            !item.receiver.profileImage.xs.includes("profile-16") &&
                              <img src={`${process.env.REACT_APP_IMGLINK}${item.receiver.profileImage.xs}`} className="realprofileimg" />
                              || <img src={profile} className="profilelogo" />
                            } */}
                            </span>
                            <span>
                              {" "}
                              {/* {item.receiver && item.receiver.name}{" "}
                            {item.receiver && item.receiver.subName} */}
                              {item.userName}
                            </span>
                            <span className="hidden-for-desktop">{item.bankName}</span>
                          </div>
                        </td>
                        <td className="amt hidden-for-mobile">
                          <div className="innerTd">{item.bankName}</div>
                        </td>
                        <td className="amount hidden-for-mobile">
                          <div className="innerTd">
                            {item.bankAccountNumber}
                          </div>
                        </td>
                        <td className="claimbtnouter hidden-for-mobile">
                          <div className="innerTd">
                            <div className="holderforbutton">
                              {item.Status && item.Status === "Activated" ? (
                                // <div className="approve">
                                //   <CustomButton
                                //     disable={item?.Status === "Activated" ? true : false}
                                //     classname={item?.Status === "Activated" ? 'disabledBtn' : null}
                                //     name={"Approve"}
                                //     filled={true}
                                //     primary={true}
                                //     onClick={() => {
                                //       setShowApproval(true);
                                //       setSelectedAccountId(item.id)
                                //     }}
                                //   />
                                // </div>
                                <div className=" statustext">
                                  <span>{t("Approved")}</span>
                                </div>
                              ) : item.Status && item.Status === "Rejected" ? (
                                // <div className="reject">
                                //   <CustomButton
                                //     disable={item?.Status === "Rejected" ? true : false}
                                //     name={"Reject"}
                                //     filled={true}
                                //     primary={true}
                                //     onClick={() => {
                                //       setShowRejection(true);
                                //       setSelectedAccountId(item.id)
                                //     }}
                                //     classname={item?.Status === "Rejected" ? 'disabledBtn' : null}
                                //   />
                                // </div>
                                <div className=" statustext">
                                  <span>{t("Rejected")}</span>
                                </div>
                              ) : (
                                <>
                                  <div className="approve">
                                    <CustomButton
                                      disable={
                                        item?.Status === "Activated"
                                          ? true
                                          : false
                                      }
                                      classname={
                                        item?.Status === "Activated"
                                          ? "disabledBtn"
                                          : null
                                      }
                                      name={t("Approve")}
                                      filled={true}
                                      primary={true}
                                      onClick={() => {
                                        setShowApproval(true);
                                        setSelectedAccountId(item.id);
                                      }}
                                    />
                                  </div>
                                  <div className="reject">
                                    <CustomButton
                                      disable={
                                        item?.Status === "Rejected"
                                          ? true
                                          : false
                                      }
                                      name={t("Reject")}
                                      filled={true}
                                      primary={true}
                                      onClick={() => {
                                        setShowRejection(true);
                                        setSelectedAccountId(item.id);
                                      }}
                                      classname={
                                        item?.Status === "Rejected"
                                          ? "disabledBtn"
                                          : null
                                      }
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </td>

                        <td className="completed">
                          <div className="vertical innerTd">
                            <Dropdown className="hidden-for-mobile">
                              <Dropdown.Toggle
                                className="threedot"
                                id="dropdown-basic"
                              >
                                <VerticleIcon className="arrowiconclass " />
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="menu">
                                <Dropdown.Item
                                  onClick={() => {
                                    //  setcoinItem(items);
                                    setshow(true);
                                    setSelectedItem(item);
                                  }}
                                >
                                  {t("Details")}
                                </Dropdown.Item>
                                {/* <Dropdown.Item
                                    // onClick={() => {
                                    //   openModal(), setname("Delete");
                                    // }}
                                    >
                                    Cancel
                                    </Dropdown.Item> */}
                              </Dropdown.Menu>
                            </Dropdown>
                            <Replacementof3dots
                              className=" arrow hidden-for-desktop"
                              onClick={() => {
                                setshow(true);
                                setSelectedItem(item);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
              {requestBankAccountCount > limit && (
                <div className="paginationsection">
                  <div className="paginationtxtholer">
                    <span className="noofpagetxt">
                      {t("Showing")} {pages + 1} {t("From")}{" "}
                      {Math.ceil(requestBankAccountCount / limit)}
                    </span>
                  </div>
                  <div className="paginationallignment">
                    <ReactPaginate
                      previousLabel={
                        <PreviousIcon className="paginationicon" />
                      }
                      nextLabel={<NextIcon className="paginationicon" />}
                      breakLabel={"..."}
                      breakClassName={"break-me"}
                      pageCount={requestBankAccountCount / limit}
                      forcePage={pages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={1}
                      onPageChange={(e) => {
                        if (isFilterSet === true) {
                          callAllBankAccountForVerification({
                            skip: e.selected * limit,
                            limit,
                            status: statusType,
                            startDate: startDate,
                            endDate: endDate,
                          });
                        } else {
                          callAllBankAccountForVerification({
                            skip: e.selected * limit,
                            limit,
                            status: statusType,
                            startDate: startDate,
                            endDate: endDate,
                          });
                        }
                        setpages(e.selected);
                      }}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />
                  </div>
                </div>
              )}

              <ApprovalPopup
                onClick={() => {
                  approveBankAccount({
                    id:
                      selectedAccountId !== undefined ? selectedAccountId : "",
                    status: "Activated",
                  });
                  setShowApproval(false);
                }}
                id={selectedAccountId}
                show1={show1}
                setShowModal={(e) => setShowApproval(e)}
              />
              <RejectionPopup
                onClick={() => {
                  approveBankAccount({
                    id:
                      selectedAccountId !== undefined ? selectedAccountId : "",
                    status: "Rejected",
                  });
                  setShowRejection(false);
                }}
                show1={show2}
                id={selectedAccountId}
                setShowModal={(e) => setShowRejection(e)}
              />
            </Col>
          </Row>
        </Container>
      </ScreenLayout>
    </div>
  );
}
const mapStateToProps = ({
  app = {},
  wallet = {},
  paymentlink = {},
  translationLanguage = {},
  admin = {},
}) => {
  const mywalletsinfo = _.get(wallet, "mywalletsinfo", []);
  const paymenthistory = _.get(paymentlink, "paymenthistory", []);
  const myaccountandbalance = _.get(
    wallet,
    "myaccountandbalancebywalletidinfo",
    []
  );
  const myusertransactionloading = _.get(
    paymentlink,
    "paymenthistoryLoading",
    false
  );
  const getpaymenthistoryCount = _.get(
    wallet,
    "getpaymenthistoryCount.count",
    10
  );
  const getplatformTokensinfo = _.get(wallet, "getplatformTokensinfo", []);
  const exchangeRates = _.get(wallet, "exchangeRates", 1);
  const paymentlinkmodal = _.get(app, "paymentlinkmodal", false);
  const paymentlinksuccmodal = _.get(app, "paymentlinksuccmodal", false);
  const paymentToken = _.get(paymentlink, "paymentToken", false);
  const createPaymentFail = _.get(paymentlink, "createPaymentFail", "");
  const createloaders = _.get(paymentlink, "createPaymentLoading", false);

  const paymentbytoken = _.get(paymentlink, "paymentbytoken", false);
  const commissionPercentage = _.get(
    paymentlink,
    "commissionPercentage",
    false
  );
  const thememode = _.get(app, "thememode", false);
  const settings = _.get(app, "settings", false);
  const currentLang = _.get(translationLanguage, "language", false);
  const requestedAccountVerification = _.get(
    admin,
    "requestedAccountVerification",
    []
  );
  const requestedAccountVerificationLoading = _.get(
    admin,
    "requestedAccountVerificationLoading",
    false
  );
  const requestBankAccountCount = _.get(admin, "bankAccountRequest", undefined);
  return {
    thememode,
    settings,
    mywalletsinfo,
    paymenthistory,
    myaccountandbalance,
    getpaymenthistoryCount,
    myusertransactionloading,
    getplatformTokensinfo,
    exchangeRates,
    paymentlinkmodal,
    paymentlinksuccmodal,
    paymentToken,
    createloaders,
    paymentbytoken,
    commissionPercentage,
    currentLang,
    createPaymentFail,
    requestedAccountVerification,
    requestedAccountVerificationLoading,
    requestBankAccountCount,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getExchangerate: (data) =>
    dispatch({ type: "getExchangeratecalled", payload: data }),
  getPaymentHistoryyCount: (data) =>
    dispatch({ type: "getpaymetHistoryCountCalled", payload: data }),
  getPaymentHistory: (data) =>
    dispatch({ type: "getPaymentHistoryCalled", payload: data }),
  createpaymentLink: (data) =>
    dispatch({ type: "createpaymentLinkCalled", payload: data }),
  setPaymentlink: (data) =>
    dispatch({ type: "setPaymentlinkCalled", payload: data }),
  setPaymentlinkSucc: (data) =>
    dispatch({ type: "setPaymentlinkSuccCalled", payload: data }),
  getcomissionper: (data) =>
    dispatch({ type: "getcomissionperCalled", payload: data }),
  callAllBankAccountForVerification: (data) =>
    dispatch({ type: "requestedAccountVerification", payload: data }),
  approveBankAccount: (data) =>
    dispatch({ type: "VerifyUserAccountRequest", payload: data }),
  bankAccountCount: (data) =>
    dispatch({ type: "bankRequestCount", payload: data }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminBankapprovalRequest);
